var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialLightbulbOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.667,
    height: 16.667,
    viewBox: "0 0 11.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-lightbulb-outline",
    "data-name": "Icon material-lightbulb-outline",
    d: "M7.5,17.5a.836.836,0,0,0,.833.833h3.333A.836.836,0,0,0,12.5,17.5v-.833h-5ZM10,1.667A5.831,5.831,0,0,0,6.667,12.283v1.883A.836.836,0,0,0,7.5,15h5a.836.836,0,0,0,.833-.833V12.283A5.831,5.831,0,0,0,10,1.667Zm2.375,9.25-.708.5v1.917H8.333V11.417l-.708-.5a4.167,4.167,0,1,1,4.75,0Z",
    transform: "translate(-4.167 -1.667)",
    fill: "#6eb104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialLightbulbOutline);
export default __webpack_public_path__ + "static/media/material-lightbulb-outline.5aa7db8fcd86135298daba47bf09ec00.svg";
export { ForwardRef as ReactComponent };